import React from 'react';
import {useNavigate} from 'react-router';
import useUtenti from '../../hooks/useUtenti';


const EmailSent = ({userData}) => {
  const navigate = useNavigate();
  const { loadingStateUtenti, resendEmailNoAuth } = useUtenti();

  const onResendEmailRegister = async () => {
    const email = {username: userData.username}
    await resendEmailNoAuth(email);
  }

  return (
    <div className="email-sender-body" style={{ height: '100%' }}>
    <div className="text-center fade-in-down">
        <i className="bi bi-envelope-check text-success"></i>
        <p className="fs-4">Un'email di conferma è stata inviata a {userData?.username}. Per favore, conferma il link e clicca su "Accedi".</p>
        <button type='button' onClick={() => navigate("/accedi")} className="btn btn-primary">Accedi</button>
        {
          !loadingStateUtenti.isLoadingResendEmailNoAuth ? 
          <p className="my-4"><span className='text-muted'>Non hai ricevuto l'email?</span> <u role='button' onClick={onResendEmailRegister}>Rinvia e-mail</u></p>
          : 
          <p className="my-4"><span className='text-muted'>Non hai ricevuto l'email?</span> <u className='text-muted'>Rinvia e-mail</u></p>
        }
        
    </div>
    </div>
  )
}

export default EmailSent;